import {List} from 'immutable'

function exist(obj, cb, def){
    let result;
    if(obj)
        result = cb(obj)
    if(result != null) {
        return result
    }
    return def;
}

// if we have an id, we are logged in
const isLoggedIn = (state) => state.getIn(['user', 'login', 'id']) > 0;
const getId = (state) => state.getIn(['user', 'login', 'id'])
const getInfo = (state) => {
    let userId = state.getIn(['user', 'login', 'id'])
    return state.getIn(['employee', 'items', userId])
    }
const getName = (state) => {
    let userId = state.getIn(['user', 'login', 'id'])
    return state.getIn(['employee', 'items', userId, 'name'], '')
    }

const getToken = (state) => state.getIn(['user', 'login', 'token'])
const getRole = (state) => {
   const id = getId(state)
   return state.getIn(['employee', 'items', id, 'role'], 'employee')
}
//==================================== SEARCH =====================================
const searchIsFetching = (state) => state.getIn(['user', 'search', 'isFetching'])
const searchResults = (state) => state.getIn(['user', 'search', 'results'])

//=============================== NOTIFICATION ====================================
const _soundNotifyIsOn = (state) => state.getIn(['user', 'localSettings', 'notifySound'])
const _webNotifyIsOn = (state) => state.getIn(['user', 'localSettings', 'notifyWeb'])
const _mutedTypes = (state) => state.getIn(['user', 'localSettings', 'mutedNotifications'])

const soundNotifyIsOn = (state) => exist(state, _soundNotifyIsOn, true)
const webNotifyIsOn = (state) => exist(state, _webNotifyIsOn, true)
const mutedTypes = (state) => exist(state, _mutedTypes, List())

export default {
   isLoggedIn,
   getId, getRole,getInfo,getName,
   getToken,
   searchIsFetching,
   searchResults,
   soundNotifyIsOn,
   webNotifyIsOn,
   mutedTypes
}



// WEBPACK FOOTER //
// ./src/model/User/selector.js